// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"587267e2","125":"8e2d1060","165":"1b29e538","217":"b2283e26","405":"bd66e2d2","453":"9e1e7267","563":"2c87c8a2","574":"11893b03","609":"8df4cbcf","639":"60ada561","642":"ecfc9c11","685":"1e9e60dc","996":"f79d59e1"}[chunkId] + ".chunk.js";
};